import React, { useState } from 'react';

interface AdminLoginProps {
  onLogin: (password: string) => void;
  error?: string;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin, error }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(password);
  };

  return (
    <div className="modern-login">
      <div className="login-card">
        <h2>Administration</h2>
        <p className="login-subtitle">Accès réservé</p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="password"
              id="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="modern-input"
            />
          </div>
          <button type="submit" className="modern-btn primary">Se connecter</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
